export default __webpack_public_path__ + "static/media/BoyPage2.42c61988.txt";